<script>
export default {
  name: 'DirectboxReceive',
  props: {
    size: {
      type: [Number, String],
      default: 24,
    },
    color: {
      type: String,
      default: '#8E8E8E',
    },
  },
}
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 18 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.5973 7.68666C13.2068 7.58666 12.7479 7.53333 12.2 7.53333C11.4397 7.53333 11.1589 7.71333 10.7685 7.99999C10.7479 8.01333 10.7274 8.03333 10.7068 8.05333L10.0562 8.72666C9.50821 9.28666 8.52191 9.29333 7.97397 8.71999L7.32328 8.05333C7.30273 8.03333 7.28219 8.01333 7.26164 7.99999C6.87123 7.71333 6.59041 7.53333 5.83013 7.53333C5.28219 7.53333 4.82328 7.58666 4.43287 7.68666C2.80273 8.11332 2.80273 9.37333 2.80273 10.48V11.1C2.80273 12.7733 2.80273 14.6667 6.46712 14.6667H11.563C13.9945 14.6667 15.2274 13.4667 15.2274 11.1V10.48C15.2274 9.37333 15.2274 8.11332 13.5973 7.68666ZM10.611 12.2667H7.41917C7.1589 12.2667 6.94657 12.06 6.94657 11.8C6.94657 11.54 7.1589 11.3333 7.41917 11.3333H10.611C10.8712 11.3333 11.0836 11.54 11.0836 11.8C11.0836 12.06 10.8712 12.2667 10.611 12.2667Z"
      :fill="color"
    />
    <path
      d="M9.4725 1.78004C9.4725 1.53337 9.26702 1.33337 9.01359 1.33337C8.76017 1.33337 8.55469 1.53337 8.55469 1.78004V2.66671H9.47935V1.78004H9.4725Z"
      :fill="color"
    />
    <path
      d="M13.9529 5.61329V6.74663C13.9255 6.73329 13.8912 6.72663 13.8638 6.71996H13.857C13.3707 6.59329 12.8296 6.53329 12.1995 6.53329C11.1447 6.53329 10.6447 6.83329 10.1926 7.16663C10.0967 7.23329 10.0282 7.29996 9.95973 7.36663L9.30905 8.03996C9.24056 8.10663 9.13097 8.14663 9.01453 8.14663C8.95973 8.14663 8.82275 8.13996 8.72001 8.03329L8.04877 7.34663C7.98028 7.27329 7.89809 7.21329 7.87754 7.19996C7.38439 6.83329 6.88439 6.53329 5.8296 6.53329C5.19946 6.53329 4.65836 6.59329 4.16521 6.71996C4.13782 6.72663 4.10357 6.73329 4.07617 6.74663V5.61329C4.07617 4.23329 4.07617 2.66663 7.10357 2.66663H8.55562V4.96663L8.11042 4.53329C7.92549 4.35329 7.63782 4.35329 7.45288 4.53329C7.2748 4.70663 7.2748 4.99329 7.45288 5.16663L8.68576 6.36663C8.69261 6.37329 8.69946 6.37329 8.69946 6.37996C8.74056 6.41329 8.7885 6.44663 8.83645 6.46663C8.89809 6.48663 8.95288 6.49996 9.01453 6.49996C9.07617 6.49996 9.13097 6.48663 9.19261 6.46663C9.24741 6.44663 9.29535 6.41329 9.34329 6.36663L10.5762 5.16663C10.7543 4.99329 10.7543 4.70663 10.5762 4.53329C10.3912 4.35329 10.1036 4.35329 9.91864 4.53329L9.47343 4.96663V2.66663H10.9255C13.9529 2.66663 13.9529 4.23329 13.9529 5.61329Z"
      :fill="color"
    />
  </svg>
</template>
